module.exports = __webpack_public_path__ + "img/my-token.04652013.svg";